import { connect } from 'react-redux';
import {
  fetchPaymentMethods,
  fetchConfigurationDetail,
  createNewConfiguration,
  removeConfiguration,
  updateConfiguration,
  fetchPaymentMethodCategories,
} from 'reducers/paymentConfiguration/actions';
import getAllPaymentMethods from 'selectors/getAllPaymentMethods';
import getConfigurationDetail from 'selectors/getConfigurationDetail';
import getPaymentMethodCategories from 'selectors/getPaymentMethodCategories';
import getPaymentConfigurationErrorMessage from 'selectors/getPaymentConfigurationErrorMessage';
import PaymentConfigurationForm from './PaymentConfigurationForm';

function mapStateToProps(state, ownProps) {
  const { configurationId } = ownProps;
  const configuration = getConfigurationDetail(state, configurationId);

  return {
    isLoading: configurationId && !configuration,
    configuration,
    paymentMethods: getAllPaymentMethods(state),
    paymentMethodCategories: getPaymentMethodCategories(state),
    errorMessage: getPaymentConfigurationErrorMessage(state),
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const { configurationId } = ownProps;
  return {
    onLoad: () => {
      dispatch(fetchPaymentMethodCategories());
      dispatch(fetchPaymentMethods());

      if (configurationId) {
        dispatch(fetchConfigurationDetail(configurationId));
      }
    },
    createNewConfiguration: newConfiguration => {
      dispatch(createNewConfiguration(newConfiguration));
    },
    updateConfiguration: patchBody => {
      dispatch(updateConfiguration(configurationId, patchBody));
    },
    deleteConfiguration: configurationId => {
      dispatch(removeConfiguration(configurationId));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentConfigurationForm);
